import MaturitiesHome from './maturities-home';

export default {
  MaturitiesHome
}
